import { declareString } from "@1js/localization";

export const OverflowMenuTooltip = declareString(
  "promptLibrary.overflowMenuTooltip",
  {
    text: "More actions",
    comment:
      "Tooltip that is displayed to user when user hovers over the overflow menu button icon on a Copilot prompt card",
  }
);
